import React from "react";
import { Icon, IconProps } from "../Icon/Icon";

export const BugIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      width="102px"
      height="96px"
      viewBox="0 0 102 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M85.069 52.1623C85.069 54.681 82.9702 56.5 80.5914 56.5H72.8955V58.7388C72.8955 61.8172 72.1959 64.7556 70.9366 67.4142L79.3321 75.8097C81.1511 77.4888 81.1511 80.4273 79.3321 82.1064C77.653 83.9254 74.7146 83.9254 73.0354 82.1064L65.3396 74.4105C61.8414 77.209 57.5037 78.8881 52.7463 78.8881V44.7463C52.7463 43.9067 51.9067 43.0672 51.0672 43.0672H47.709C46.7295 43.0672 46.0299 43.9067 46.0299 44.7463V78.8881C41.1325 78.8881 36.7948 77.209 33.2966 74.4105L25.6007 82.1064C23.9216 83.9254 20.9832 83.9254 19.3041 82.1064C17.4851 80.4273 17.4851 77.4888 19.3041 75.8097L27.6996 67.4142C26.4403 64.7556 25.8806 61.8172 25.8806 58.7388V56.5H18.0448C15.666 56.5 13.5672 54.681 13.5672 52.1623C13.4272 49.6437 15.5261 47.5448 18.0448 47.5448H25.8806V39.4291L19.3041 32.8526C17.4851 31.1735 17.4851 28.2351 19.3041 26.556C20.9832 24.737 23.9216 24.737 25.6007 26.556L33.2966 34.112H65.3396L73.0354 26.556C74.7146 24.737 77.653 24.737 79.3321 26.556C81.1511 28.2351 81.1511 31.1735 79.3321 32.8526L72.8955 39.4291V47.5448H80.7313C83.1101 47.5448 85.209 49.6437 85.069 52.1623ZM49.528 11.7239C58.0634 11.7239 65.1996 18.8601 65.1996 27.3955H33.8563C33.8563 18.8601 40.8526 11.7239 49.528 11.7239Z"
        fill="#F2EAE2"
      />
      <path
        d="M93.5533 75.4778L95.973 72.3982L99.9038 71.9726L96.7724 69.5588L96.3149 65.6691L93.8952 68.7487L90.0951 69.2111L93.0958 71.5881L93.5533 75.4778Z"
        fill="#FF9800"
      />
      <path
        d="M41.21 92.0536C40.8789 90.8182 39.6099 90.0106 38.3004 90.3615C37.0728 90.6905 36.2736 91.9639 36.6267 93.2817C36.9577 94.5171 38.2268 95.3246 39.5363 94.9737C40.7639 94.6448 41.5631 93.3714 41.21 92.0536Z"
        fill="#FF478F"
      />
      <path
        d="M93.1698 23.8992C93.5008 22.6637 92.8056 21.3299 91.4961 20.979C90.2684 20.6501 88.9396 21.3533 88.5865 22.6711C88.2555 23.9065 88.9508 25.2403 90.2603 25.5912C91.4879 25.9202 92.8167 25.2169 93.1698 23.8992Z"
        fill="#FF478F"
      />
      <path
        d="M26.4894 9.96544L28.6151 7.18236L32.117 6.75476L29.2981 4.63355L28.8487 1.16047L26.723 3.94355L23.3382 4.40251L26.04 6.49236L26.4894 9.96544Z"
        fill="#FF9800"
      />
      <path
        d="M5.7892 73.0746L7.4704 69.0024L11.597 67.3433L7.4704 65.6842L5.7892 61.612L4.10801 65.6842L0.134277 67.3433L4.10801 69.0024L5.7892 73.0746Z"
        fill="#FF9800"
      />
    </Icon>
  );
};
